<div class="footer2 mainDiv mainDiv-height col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12">
    <div class="col-md-9 col-sm-12 col-lg-9 col-xl-9 col-xs-9">
      <span class="left-text">©{{currentYear}} UnitedHealth Group. All rights reserved.</span>
    </div>
    <div class="contact col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3">
        <div class="contactRow row  contactusrow-align" style="width: 100%;">
    
            <!-- footer-Image-contact -->
            <div class="contactusDiv-images contactusDiv-images-margin contactusDiv-images-cursor">
                <a [routerLink]="['/contact-us']" rel="noopener noreferrer">
                    <img class="footer-Image-contact" style="border-radius: 3px;"
                        src="../../../../assets/imagesV4/Contact.png" matTooltip="Contact" matTooltipPosition="above">
                </a>
            </div>
    
    
        </div>
    </div>
</div>
